import { render, staticRenderFns } from "./patients-postpay-form.vue?vue&type=template&id=c81c24a2"
import script from "./patients-postpay-form.vue?vue&type=script&lang=js"
export * from "./patients-postpay-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports